import { render } from "./LeaderboardWidget.vue?vue&type=template&id=1997f6e5&scoped=true"
import script from "./LeaderboardWidget.vue?vue&type=script&lang=js"
export * from "./LeaderboardWidget.vue?vue&type=script&lang=js"

import "./LeaderboardWidget.vue?vue&type=style&index=0&id=1997f6e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1997f6e5"]])

export default __exports__